<template>
    <section id="service-area" class="service-area-section">
        <div class="service-area-header">
            <div class="area-image">
                <img src="@/assets/projects/driveways/driveway-03.jpg"
                     alt="MMP Concrete LLC driveway project in North Mississippi"
                     loading="lazy" />
                <div class="image-overlay"></div>
            </div>

            <div class="area-content">
                <p class="eyebrow">
                    <span></span>
                    {{ t.area.eyebrow }}
                </p>

                <h2>
                    {{ t.area.titleFirst }}
                    <em>{{ t.area.titleSecond }}</em>
                </h2>

                <p class="area-description">
                    {{ t.area.description }}
                </p>

                <a class="availability-button" href="#contact">
                    {{ t.area.button }}

                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M5 12h14"></path>
                        <path d="m13 6 6 6-6 6"></path>
                    </svg>
                </a>
            </div>
        </div>

        <div class="container area-details">
            <div class="cities-area">
                <div class="section-identifier">
                    {{ t.navigation.area }}
                </div>

                <div class="cities-grid">
                    <div v-for="city in t.area.cities"
                         :key="city"
                         class="city">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 21s7-5.2 7-12a7 7 0 1 0-14 0c0 6.8 7 12 7 12Z" />
                            <circle cx="12" cy="9" r="2.5" />
                        </svg>

                        <span>{{ city }}</span>
                    </div>
                </div>
            </div>

            <div class="map-container">
                <iframe title="MMP Concrete LLC service area in Mississippi"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6938617.235320173!2d-93.50410111718838!3d32.85826157952906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8880cabd6b2b1b3b%3A0x179bd3e34d05d722!2sMississippi!5e0!3m2!1sen!2sus!4v1714592089556!5m2!1sen!2sus"
                        loading="lazy"
                        allowfullscreen
                        referrerpolicy="no-referrer-when-downgrade"></iframe>

                <div class="map-label">
                    <strong>North Mississippi</strong>
                    <span>& surrounding areas</span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'ServiceArea',

  props: {
    t: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
    .service-area-section {
        color: var(--color-white);
        background-color: var(--color-charcoal);
    }

    .service-area-header {
        display: grid;
        min-height: 640px;
        grid-template-columns: 1.08fr 0.92fr;
    }

    .area-image {
        position: relative;
        min-height: 540px;
        overflow: hidden;
    }

        .area-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: saturate(0.72);
        }

    .image-overlay {
        position: absolute;
        inset: 0;
        background: linear-gradient( 90deg, transparent 60%, rgba(21, 21, 19, 0.45) );
    }

    .area-content {
        display: flex;
        padding: 90px 7vw;
        justify-content: center;
        flex-direction: column;
    }

    .eyebrow {
        display: flex;
        align-items: center;
        gap: 13px;
        margin-bottom: 25px;
        color: #efa46d;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.21em;
        text-transform: uppercase;
    }

        .eyebrow span {
            width: 32px;
            height: 2px;
            background-color: currentColor;
        }

    h2 {
        max-width: 670px;
        margin: 0;
        font-family: var(--font-heading);
        font-size: clamp(52px, 5.2vw, 80px);
        font-weight: 400;
        letter-spacing: -0.045em;
        line-height: 0.98;
    }

        h2 em {
            display: block;
            color: var(--color-orange);
            font-weight: 400;
        }

    .area-description {
        max-width: 540px;
        margin: 33px 0;
        color: #aaa69e;
        font-size: 16px;
        line-height: 1.8;
    }

    .availability-button {
        display: inline-flex;
        align-items: center;
        align-self: flex-start;
        justify-content: center;
        gap: 16px;
        padding: 18px 23px;
        background-color: var(--color-orange);
        border: 1px solid var(--color-orange);
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.13em;
        text-transform: uppercase;
        transition: background-color 0.25s ease, transform 0.25s ease;
    }

        .availability-button:hover {
            background-color: var(--color-orange-dark);
            transform: translateY(-2px);
        }

        .availability-button svg {
            width: 18px;
            fill: none;
            stroke: currentColor;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 1.8;
        }

    .area-details {
        display: grid;
        padding-block: 90px;
        grid-template-columns: 0.9fr 1.1fr;
        gap: 70px;
    }

    .section-identifier {
        display: flex;
        align-items: center;
        gap: 14px;
        margin-bottom: 40px;
        color: #aaa69e;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.2em;
        text-transform: uppercase;
    }

        .section-identifier > span {
            display: grid;
            width: 33px;
            height: 33px;
            place-items: center;
            color: #efa46d;
            border: 1px solid rgba(255, 255, 255, 0.25);
            font-size: 9px;
        }

    .cities-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        border-top: 1px solid rgba(255, 255, 255, 0.14);
    }

    .city {
        display: flex;
        align-items: center;
        gap: 11px;
        min-height: 48px;
        color: #c5c1b8;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 12px;
    }

        .city:nth-child(odd) {
            border-right: 1px solid rgba(255, 255, 255, 0.1);
        }

        .city:nth-child(even) {
            padding-left: 20px;
        }

        .city svg {
            width: 15px;
            fill: none;
            stroke: var(--color-orange);
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 1.5;
        }

    .map-container {
        position: relative;
        min-height: 480px;
        overflow: hidden;
        background-color: var(--color-charcoal-light);
    }

        .map-container iframe {
            width: 100%;
            height: 100%;
            min-height: 480px;
            border: 0;
            filter: grayscale(0.65) contrast(0.95);
        }

    .map-label {
        position: absolute;
        right: 20px;
        bottom: 20px;
        display: flex;
        min-width: 215px;
        padding: 17px 20px;
        background-color: rgba(21, 21, 19, 0.92);
        flex-direction: column;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.32);
    }

        .map-label strong {
            color: var(--color-white);
            font-family: var(--font-heading);
            font-size: 19px;
            font-weight: 400;
        }

        .map-label span {
            margin-top: 5px;
            color: #aaa69e;
            font-size: 10px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
        }

    @media (max-width: 900px) {
        .service-area-header {
            grid-template-columns: 1fr;
        }

        .area-image {
            min-height: 390px;
        }

        .area-content {
            padding: 80px 25px;
        }

        .area-details {
            grid-template-columns: 1fr;
            gap: 55px;
        }
    }

    @media (max-width: 520px) {
        .area-image {
            min-height: 310px;
        }

        .cities-grid {
            grid-template-columns: 1fr;
        }

        .city:nth-child(odd) {
            border-right: 0;
        }

        .city:nth-child(even) {
            padding-left: 0;
        }

        .map-container,
        .map-container iframe {
            min-height: 390px;
        }

        .map-label {
            right: 12px;
            bottom: 12px;
            left: 12px;
        }
    }
</style>